import createPermission from 'permissions/createPermission'

export const meteo = createPermission('unit.meteo')